import { DropOffPrintIconDto } from 'types/dtos'
import { DropOffPrintIconModel } from 'types/models'

export const transformDropOffPrintIcon = (
  dropOffPrintIcon: DropOffPrintIconDto,
): DropOffPrintIconModel => ({
  url: dropOffPrintIcon.url,
  text: dropOffPrintIcon.text,
})
